import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar6"><Path d="M19.75 17.5H22.5V9.75L17 8.75L14 4.5L1.5 4.5V17.5H4.25" stroke="currentColor"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor"/><Path d="M9.75 17.5H14.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconCar6;
